import QueryBuilder from "../QueryBuilder"

export default class BannerRepository {
    constructor(protected contentName: string) {}

    async fetch() {
        const results = await new QueryBuilder()
            .buildQuery(this.contentName, [
                "bannerText",
                "text_highlight",
                "banner_label",
                "subheaderText",
                "imagePanel",
            ])
            .process()

        return results.getResultInfo()
    }
}
